export const WORDS = {
    SITE_NAME: "kosarev.app",
    // Должно совпадать с <title> в public/index.html
    RESUME_TITLE: "Vsevolod Kosarev — Unity C# Developer",
    NAV_HOME: "Home",
    NAV_PROJECTS: "Projects",
    LEARNING_CARDS_SERVICE: "Flashcards 🏷",
    BUTTON_ADD_CARD: "Add",
    BUTTON_EDIT_GROUP: "Edit",
    BUTTON_DELETE_GROUP: "Delete"
};